







































































import Vue from 'vue'
import { getTxStatus, setTxCount } from '@/api/payment'
import { IGetTxStatusRequest, ISetTxCountRequest } from '@/interfaces/payment'
import { ICartItem } from '@/interfaces/cart'
import * as Event from '@/utils/sendEvent'
import postAppMessage, { MessageHandlers } from '@/utils/poster'
import { MetaInfo } from 'vue-meta/types/vue-meta'

export default Vue.extend({
  name: 'Payment',
  props: {
    orderId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      showFrame: false,
      iframeLoadedCount: 0,
      getTxStatusTimerId: 0 as number,
      transTimerId: 0 as number,
      txStatus: 0,
      txCount: 1,
      getTxStatusHitCount: 0,
      isGetTxStatusApiPending: false,
      requestBody: {} as IGetTxStatusRequest | ISetTxCountRequest,
      bankTransResult: null as boolean | null, // true = success, false = failure, null = unknown
      hasSetTxCount: false,
      isLoading: false,
      isTimerStarted: false,
      isMobileAspect: window.matchMedia('(max-aspect-ratio: 1/1)').matches
    }
  },
  metaInfo (): MetaInfo {
    return {
      title: '信用卡付款',
      titleTemplate: '%s | nuPhoto 拍立洗'
    }
  },
  computed: {
    validateOrderId (): boolean {
      if (this.orderId.length !== 20) { return false }
      // Other validations?
      return true
    },
    cartList (): Array<ICartItem> {
      const tempCartList = this.$store.getters.cartList as Array<ICartItem>
      return tempCartList.filter(item => item.checked === 1)
    }
  },
  watch: {
    txStatus: function (newValue, oldValue) {
      if (newValue === 1 && oldValue !== newValue) {
        clearInterval(this.getTxStatusTimerId)
      }
    }
  },
  created () {
    window.navigateBack = this.onBackButtonClicked
  },
  mounted () {
    if (this.validateOrderId) {
      this.$store.commit('logger/PUSH_LOG', `orderId: ${this.orderId}`)
      const paymentForm = this.$refs.payment as HTMLFormElement
      paymentForm.submit()
      this.isLoading = true
    } else {
      this.$bvModal.msgBoxOk('訂單編號錯誤，請聯絡客服協助處理。', {
        centered: true,
        noCloseOnBackdrop: true,
        noCloseOnEsc: true,
        footerClass: 'msgbox-ok-footer',
        okTitle: '確定'
      }).then(() => {
        this.$router.replace({ name: 'Order', query: this.$route.query })
      })
    }
  },
  beforeDestroy () {
    this.stopGetTxStatusTimer()
    this.stopTransTimer()
  },
  methods: {
    startGetTxStatusTimer () {
      this.$store.commit('logger/PUSH_LOG', 'startGetTxStatusTimer')
      this.requestBody = {
        token: this.$route.query.token || this.$store.getters.token,
        app_index: 6,
        order_id: this.orderId
      } as IGetTxStatusRequest
      this.$store.commit('logger/PUSH_LOG', this.requestBody)
      if (this.isTimerStarted === false) {
        this.getTxStatusTimerId = setInterval(() => { this.checkTxStatus() }, 2000)
        this.isTimerStarted = true
      }
    },
    stopGetTxStatusTimer () {
      this.isTimerStarted = false
      if (this.getTxStatusTimerId) {
        this.$store.commit('logger/PUSH_LOG', 'stopGetTxStatusTimer')
        clearInterval(this.getTxStatusTimerId)
        this.getTxStatusTimerId = 0
      }
    },
    async checkTxStatus (ignorePending = false) {
      if (!ignorePending && this.isGetTxStatusApiPending) {
        return
      }

      this.getTxStatusHitCount += 1
      this.isGetTxStatusApiPending = true
      try {
        const { data } = await getTxStatus(this.requestBody)
        this.isGetTxStatusApiPending = false
        this.txStatus = data[0].flag || 0
        if (this.txStatus === 1) {
          this.$store.commit('logger/PUSH_LOG', 'txStatus: 1, stopGetTxStatusTimer')
          this.stopGetTxStatusTimer()
          if (!this.hasSetTxCount) {
            this.handleSetTxCount()
            this.hasSetTxCount = true
          }
          this.showTransactionSuccessModal()
        }
      } catch (error) {
        this.$store.commit('logger/PUSH_LOG', error)
        console.error(error)
      } finally {
        this.isGetTxStatusApiPending = false

        if (this.getTxStatusHitCount >= 150 && this.txStatus !== 1) {
          this.stopGetTxStatusTimer()
          this.showTransactionTimeoutModal()
        }
      }
    },
    showTransactionTimeoutModal (forceExit = false) {
      this.isLoading = false
      const h = this.$createElement
      if (forceExit) {
        this.stopGetTxStatusTimer()
        const messageVNode = [
          h('p', '信用卡交易逾時，請重新結帳'),
          h('p', '請排除網路問題，如果有疑問請聯絡客服')
        ]

        this.$store.commit('logger/PUSH_LOG', 'showTransactionTimeoutModal: 15 mins')
        this.$store.dispatch('logger/UPLOAD_LOG', { token: this.$route.query.token || this.$store.getters.token, isOrderUpload: true })

        this.$bvModal.msgBoxOk(messageVNode, {
          centered: true,
          noCloseOnBackdrop: true,
          noCloseOnEsc: true,
          footerClass: 'msgbox-ok-footer',
          okTitle: '確定'
        }).then(() => {
          this.$router.replace({ name: 'Checkout', query: this.$route.query })
        })
        return
      }

      const messageVNode = [
        h('p', '信用卡交易尚未完成,是否要繼續等待交易結果？'),
        h('p', '請排除網路問題，如果有疑問請聯絡客服')
      ]

      this.$store.commit('logger/PUSH_LOG', 'showTransactionTimeoutModal: 150 times')
      this.$store.dispatch('logger/UPLOAD_LOG', { token: this.$route.query.token || this.$store.getters.token, isOrderUpload: true })

      this.$bvModal.msgBoxConfirm(messageVNode, {
        centered: true,
        noCloseOnBackdrop: true,
        noCloseOnEsc: true,
        footerClass: 'msgbox-confirm-footer',
        cancelTitle: '否',
        okTitle: '是'
      }).then((result) => {
        if (result) {
          this.getTxStatusHitCount -= 150
          this.startGetTxStatusTimer()
        } else {
          this.$router.replace({ name: 'Checkout', query: this.$route.query })
        }
      })
    },
    showTransactionFailedModal () {
      const h = this.$createElement
      const messageVNode = [
        h('p', '信用卡交易失敗，如果有疑問請聯絡客服')
      ]

      this.$store.dispatch('logger/UPLOAD_LOG', { token: this.$route.query.token || this.$store.getters.token, isOrderUpload: true })

      this.$bvModal.msgBoxOk(messageVNode, {
        centered: true,
        noCloseOnBackdrop: true,
        noCloseOnEsc: true,
        footerClass: 'msgbox-ok-footer',
        okTitle: '確定'
      }).then(() => {
        this.$store.commit('logger/PUSH_LOG', 'showTransactionFailedModal')
        this.$router.replace({ name: 'Checkout', query: this.$route.query })
      })
    },
    showTransactionSuccessModal () {
      this.isLoading = false
      this.stopTransTimer()
      this.sendTracingData(this.orderId)
      this.clearCheckoutConfig()

      this.$bvModal.msgBoxOk('信用卡付款成功', {
        centered: true,
        noCloseOnBackdrop: true,
        noCloseOnEsc: true,
        footerClass: 'msgbox-ok-footer',
        okTitle: '確定'
      }).then(() => {
        this.$store.commit('logger/PUSH_LOG', 'showTransactionSuccessModal')
        this.$store.dispatch('logger/UPLOAD_LOG', { token: this.$route.query.token || this.$store.getters.token, isOrderUpload: true })
        this.$store.commit('SET_CART_LIST', null)
        if (this.$store.getters.isWebViewMode) {
          postAppMessage(MessageHandlers.ON_TRANSACTION_SUCCESS, true)
          this.$router.replace({ name: 'Cart', query: this.$route.query })
        } else {
          this.$router.replace({ name: 'Order' })
        }
      })
    },
    clearCheckoutConfig () {
      localStorage.removeItem('eco/checkout')
    },
    sendTracingData (orderId: string) {
      // Google Analytics
      const gTagCartItems = [] as Array<any>
      // Facebook Pixel
      const facebookCartItems = [] as Array<any>

      this.cartList.forEach(item => {
        gTagCartItems.push({
          id: item.variant_id.toString(),
          name: item.product_title,
          variant: item.title,
          quantity: item.qty,
          currency: 'TWD',
          price: item.price_text.replace(/\D/g, '')
        })

        facebookCartItems.push({
          id: item.variant_id.toString(),
          quantity: item.qty
        })
      })

      const amount = this.$store.getters['order/amount']
      // let amount = this.$store.getters['order/amount']
      // if (amount < 3) { amount = 0 }
      this.$gtag.purchase({
        transaction_id: orderId,
        affiliation: 'nuPhoto 電商網站',
        value: amount,
        currency: 'TWD',
        tax: 0,
        shipping: this.$store.getters['order/shipping'],
        items: gTagCartItems
      } as any)

      Event.purchase(orderId, amount, facebookCartItems)
      this.$store.commit('logger/PUSH_LOG', { orderId, value: amount / 33 })
    },
    async handleSetTxCount (retryCount = 0) {
      try {
        this.$store.commit('logger/PUSH_LOG', 'handleSetTxCount')
        const { data } = await setTxCount(this.requestBody as ISetTxCountRequest)
        if (data[0].flag) {
          this.$store.commit('logger/PUSH_LOG', { setTxCount: '1, 3' })
        }
      } catch (error) {
        this.$store.commit('logger/PUSH_LOG', { setTxCountError: error })
        this.$store.commit('logger/PUSH_LOG', { setTxCount: '1, 2' })
        if (retryCount < 4) { this.handleSetTxCount(retryCount + 1) } else this.$store.commit('logger/PUSH_LOG', 'Failed call handleSetTxCount 5 times')
      }
    },
    onIframeLoaded () {
      this.iframeLoadedCount += 1
      this.$store.commit('logger/PUSH_LOG', `onIframeLoaded: ${this.iframeLoadedCount}`)
      this.$nextTick(() => {
        const iframe = this.$refs.iframe as HTMLIFrameElement
        if (iframe === undefined) return
        this.getTransResult(iframe)
      })
    },
    getTransResult (iframe: HTMLIFrameElement) {
      this.$store.commit('logger/PUSH_LOG', 'getTransResult')
      if (this.iframeLoadedCount === 3) {
        this.startGetTxStatusTimer()
        this.startTransTimer()
        this.isLoading = false
      } else {
        try {
          this.$store.commit('logger/PUSH_LOG', 'testing url')
          this.$store.commit('logger/PUSH_LOG', `iframe.contentWindow: ${iframe.contentWindow}`)
          if (iframe.contentWindow) {
            const url = iframe.contentWindow.location.href
            this.$store.commit('logger/PUSH_LOG', { transIframeLoad: iframe.contentWindow.location.href })

            if (url === 'https://nuphoto.com.tw/411_CathaybkCreditCardFinish.php') {
              this.isLoading = true
              const element = iframe.contentWindow.document.getElementById('trans_result') as HTMLElement
              this.$store.commit('logger/PUSH_LOG', { transBankMessage: element.innerHTML })

              if (/CATHAY_BANK_CREDIT_CARD_SUCCEED/g.test(element.innerHTML)) {
                if (!this.isTimerStarted) {
                  this.startGetTxStatusTimer()
                }
                this.bankTransResult = true
              } else if (/CATHAY_BANK_CREDIT_CARD_FAIL/g.test(element.innerHTML)) {
                this.stopGetTxStatusTimer()
                this.showTransactionFailedModal()
                this.stopTransTimer()
              }
            }
          }
        } catch (error) {
          console.log(error)
          this.$store.commit('logger/PUSH_LOG', error)
          this.$bvModal.msgBoxOk(`發生錯誤，請至查詢訂單確認交易是否完成，或暫時採用其他方式進行結帳，或截圖並聯繫客服人員協助您處理。錯誤：${error.message}`, {
            centered: true,
            noCloseOnBackdrop: true,
            noCloseOnEsc: true,
            footerClass: 'msgbox-confirm-footer',
            okTitle: '確定'
          })
        }
      }
    },
    startTransTimer () {
      this.transTimerId = setTimeout(() => {
        this.showTransactionTimeoutModal(true)
      }, 1000 * 60 * 15)
    },
    stopTransTimer () {
      if (this.transTimerId) {
        clearTimeout(this.transTimerId)
        this.transTimerId = 0
      }
    },
    onBackButtonClicked () {
      if (this.txStatus !== 1) {
        this.$bvModal.msgBoxConfirm('尚未交易完成，是否確認離開此頁面，若您離開後必須重新結帳。', {
          centered: true,
          noCloseOnBackdrop: true,
          noCloseOnEsc: true,
          footerClass: 'msgbox-confirm-footer',
          cancelTitle: '否',
          okTitle: '是'
        }).then((result) => {
          if (result) this.$router.go(-1)
        })
      } else {
        if (!this.$store.getters.isWebViewMode) { this.$router.replace({ name: 'Home' }) }
      }
    }
  }
})
